import { render, staticRenderFns } from "./ModalHoras.vue?vue&type=template&id=24fa997d&scoped=true&"
import script from "./ModalHoras.vue?vue&type=script&lang=js&"
export * from "./ModalHoras.vue?vue&type=script&lang=js&"
import style0 from "./ModalHoras.vue?vue&type=style&index=0&id=24fa997d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa997d",
  null
  
)

export default component.exports